import { render, staticRenderFns } from "./WPTextInfoMini.vue?vue&type=template&id=48e01dc6"
import script from "./WPTextInfoMini.vue?vue&type=script&lang=ts"
export * from "./WPTextInfoMini.vue?vue&type=script&lang=ts"
import style0 from "./WPTextInfoMini.vue?vue&type=style&index=0&id=48e01dc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports